import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['organisation', 'residences'];
  static values = { residencesUrl: String };

  loadResidences() {
    const url = new URL(this.residencesUrlValue, window.location.origin);
    url.searchParams.set(
      'target_organisation_id',
      this.organisationTarget.value
    );
    this.residencesTarget.src = url.toString();
  }
}
